import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  DropdownMenuNew,
  DualIcon,
  FormFieldSet,
  InfoCircle,
  LogoLoader,
  Modal,
  showToast,
  SmartTooltip,
  TableAdv,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { formatWords2 } from "../../../../utils/stringUtils";
import ScheduleCallModal from "./Modals/ScheduleCallModal";
import { Link } from "react-router-dom";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { fetchAllJobsStart } from "../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { fetchAllRecruitersAndBDMUsers, fetchAllSubmissions, fetchTalentMatch, userRefCount } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import JobsAccordion from "./JobsAccordion";


const AiRecruiterJobs = () => {
  // const [allRecruiters, setAllRecruiters] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [jobPostIds, setJobPostIds] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [accordionLoading, setAccordionLoading] = useState({});
  const [accordionData, setAccordionData] = useState({});
  const [scheduleModal, setScheduleModal] = useState(false);
  const [selectedModalRows, setSelectedModalRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const jobs = useSelector((state) => state?.bdmJobs?.allJobs?.data);
  const loading = useSelector((state) => state?.bdmJobs?.loading)
  const { user } = useSelector((state) => state?.auth);
  const orgId = user?.data?.organizationId?.uiid;
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { },
  );
    const [scheduleCall,setScheduleCall]=useState();
    const JobPostingStatus = {
    // 1: "Draft",
    2: "Active",
    3: "On Hold",
    4: "Hold by Client",
    5: "Interview L1",
    6: "Interview L2",
    7: "Interview L3",
    8: "Priority",
    9: "Filled",
    10: "Closed",
    11: "Agreement Sent",
    12: "Agreement Accepted",
  };

  const currencyMap = {
    1: "USD",
    2: "INR",
  };

  const employmentTypeMap = {
    1: "1099",
    2: "C2C",
    3: "C2C",
    4: "Full Time",
    5: "In-cop",
    6: "Intern",
    7: "Other",
    8: "Part Time",
    9: "W-2",
  };

  const statusOptions = Object.entries(JobPostingStatus).map(
    ([value, label]) => ({
      value: Number(value),
      label,
    }),
  );

  const scheduleInterviewRows = Array.from({ length: 5 }, (_, index) => ({
    id: index + 1,
    sNo: index + 1,
    name: "Jack Raison",
    email: "jackrai@gmail.com",
    phone: "9876543210",
    jobTitle: "Frontend Developer",
    experience: 3,
    workAuth: "USA",
    location: "Dallas",
  }));

  const scheduleInterviewCols = [
    {
      key: "sNo",
      label: "S.No",
    },
    {
      key: "name",
      label: "Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => <div className="text-info-500">{row?.name}</div>,
    },
    {
      key: "email",
      label: "Email ID",
    },
    {
      key: "phone",
      label: "Phone number",
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "experience",
      label: "Experience (In years)",
    },
    {
      key: "workAuth",
      label: "Work Authorization",
    },
    {
      key: "location",
      label: "Location",
    },
  ];

  const toggleAccordion = (rowId, accordionType) => {
    setExpandedRows((prev) => {
      if (prev[rowId] === accordionType) {
        const newState = { ...prev };
        delete newState[rowId];
        return newState;
      }
      return { ...prev, [rowId]: accordionType };
    });
  };

  const fetchRecruitersAndJobs = async () => {
    const count = await userRefCount({
      fil: JSON.stringify({
        // "role.type": { type: "IN", value: [1, 3, 4] },
        userType: { type: "NONE", value: 2 },
        status: { type: "NONE", value: 1 },
        botAssignedTo: { type: "IN", value: [user?.data?.uiid] }
      }),
    });
    const recruiterCount = count?.data?.data || 0;
    let botFilterUiids = null;
    const isAdmin = user?.data?.role?.type === 1;

    try {
      const res = await fetchAllRecruitersAndBDMUsers({
        orgId,
        lim: recruiterCount,
        ret: "uiid firstName lastName userType botAssignedTo",
        fil: JSON.stringify({
          // "role.type": { type: "IN", value: [1, 3, 4] },
          userType: { type: "NONE", value: 2 },
          status: { type: "NONE", value: 1 },
          botAssignedTo: { type: "IN", value: [user?.data?.uiid] }
        })
      });
      if (res?.data?.data) {
        // const recruiterList = res.data.data.map((r) => {
        //   const first = r.firstName || "";
        //   const last = r.lastName || "";
        //   const fullName = `${first} ${last}`.trim(); // Removes undefined
        //   const userType = r.userType || 1;

        //   return {
        //     label: fullName,
        //     value: `${fullName}-${r.uiid}`, // Consistent format
        //     userType
        //   };
        // });

        // setAllRecruiters(recruiterList);

        if (!isAdmin) {
          // const loggedInUiid = user?.data?.uiid;
          // const myBots = res.data.data.filter(r => {
          //   if (r.userType !== 2) return false;
          //   const assignedTo = r.botAssignedTo || [];
          //   const assignedUiids = assignedTo.map(bot => String(typeof bot === "object" && bot !== null ? bot.uiid || bot.value : bot));
          //   return assignedUiids.includes(String(loggedInUiid));
          // });
          botFilterUiids = res?.data?.data?.map(b => b.uiid);
        }
      }
    } catch (error) {
      console.error("Failed to fetch recruiters", error);
    }

    const jobFilters = { "aiRecruiter.isAiRecruiter": { type: "NONE", value: true } };
    if (!isAdmin && botFilterUiids) {
      jobFilters.notifyTo = { type: "IN", value: botFilterUiids };
    }

    dispatch(
      totalCountStart({
        collection: "jobpostings",
        coll: "JobPosting",
        tname: "allJobsPosts",
        app: "ats",
        filters: jobFilters,
      }),
    );
    dispatch(
      fetchAllJobsStart({
        coll: "JobPosting",
        lim: limit,
        pg: page,
        ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch aiRecruiter",
        ref: "Job Submission NotifyTo",
        fil: jobFilters,
        extret: "uiid firstName lastName",
        incl: ["", "uiid statusHistory.status currentStatus","uiid firstName lastName userType"],
        sort: { addedOn: -1 },
      }),
    );
  };

  useEffect(() => {
    fetchRecruitersAndJobs();
  }, [dispatch, page, limit, orgId, user]);

  useEffect(() => {
    if (jobs && jobs.length > 0) {
      const newRecruiterState = jobs.reduce((acc, job) => {
        acc[job.uiid] = job?.notifyTo || [];
        return acc;
      }, {});
      setRecruiter(newRecruiterState);
    }
  }, [jobs]);

  const formatPayment = (payment) => {
    if (!payment) return "";

    const currency = currencyMap[payment?.currency] || "USD";

    let amount = "";
    if (payment?.amount != null && typeof payment?.amount === "object") {
      amount = `${payment?.amount?.min || ""}-${payment?.amount?.max || ""}`;
    } else if (payment?.amount != null) {
      amount = payment?.amount;
    }

    const freq = payment?.freqType || "";
    const empType = employmentTypeMap[payment?.employmentType] || "";

    return [currency, amount, freq, empType].filter(Boolean).join("/");
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    const optionsDate = { year: "numeric", month: "long", day: "2-digit" };
    const formattedDate = date.toLocaleDateString("en-US", optionsDate);

    const optionsTime = {
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: true,
    };
    const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

    return `${formattedDate} ${formattedTime}`;
  };

  const mapSubmissionsToRows = (submissions = []) => {
    return submissions.map((submission) => {
      const candidate = submission?.candidateId || {};
      const job = submission?.jobPostId || {};
      const jobInfo = job?.jobInfo || {};
      const Currency = {
        1: "USD",
        2: "INR",
        3: "CAD",
      };
      //console.log("submission",submission)
      return {
        submissionId: submission?.uiid ?? "N/A",
        applicantName:
          `${candidate?.firstName || ""} ${candidate?.lastName || ""}`.trim() ||
          "N/A",
        workAuth: candidate?.workAuth ? candidate?.workAuth : "N/A",
        mobile: candidate?.mobile?.primary?.number
          ? `${candidate?.mobile?.primary?.code} ${candidate?.mobile?.primary?.number}`
          : "N/A",
        applicantLocation: candidate?.location
          ? [
            candidate?.location?.city,
            candidate?.location?.state,
          ]
            .filter(Boolean)
            .join(", ") : "N/A",
        country: candidate?.location?.country || "N/A",
        experience: candidate?.exp
          ? `${candidate?.exp?.year || 0}y ${candidate?.exp?.mon || 0}m`
          : "N/A",
        source: candidate?.source || "N/A",
        resume: candidate?.resumes?.length
          ? `Resume (${candidate?.resumes?.length})`
          : "N/A",
        revisionStatus: "Active",
        // applicationStatus: "In Progress", // no status field in submission itself
        applicationStatus: submission?.statusHistory || [], // no status field in submission itself

        // billRate: jobInfo.payments?.billRate?.amount
        //   ? `${jobInfo.payments.billRate.amount}`
        //   : "N/A",
        // payRate: jobInfo.payments?.payRate?.amount
        //   ? `${jobInfo.payments.payRate.amount.min}-${jobInfo.payments.payRate.amount.max}`
        //   : "N/A",
        billRate: jobInfo?.payments?.billRate?.currency
          ? `${Currency[jobInfo?.payments?.billRate?.currency] || "N/A"}-${jobInfo?.payments?.billRate?.amount || "0"
          }/${jobInfo?.payments?.billRate?.freqType || ""}/${jobInfo?.payments?.billRate?.employmentType || ""
          }`
          : "N/A",

        payRate: jobInfo?.payments?.payRate?.currency
          ? `${Currency[jobInfo?.payments?.payRate?.currency] || "N/A"}/${jobInfo?.payments?.payRate?.amount?.min || "0"
          }-${jobInfo?.payments?.payRate?.amount?.max || "0"}/${jobInfo?.payments?.payRate?.freqType || ""
          }/${jobInfo?.payments?.payRate?.employmentType || ""}`
          : "N/A",

        employerName: candidate?.currentEmp ? "Yes" : "N/A",
        availability: candidate?.noticePeriod?.days === 0 ? "Yes" : "No",
        submittedBy: formatWords2(submission?.addedBy?.firstName || "N/A"),
        pwSubmissionType: submission?.type || "N/A",
        noticePeriod: candidate?.noticePeriod
          ? `${candidate?.noticePeriod?.days} days`
          : "N/A",
        // currentCTC: candidate.salaryInfo?.payRate || "N/A",
        currentCTC: candidate?.salaryInfo?.payRate
          ? (() => {
            const { currency, amount, freqType, employmentType } =
              candidate?.salaryInfo?.payRate;
            const curr = Currency[currency] || "N/A";
            const amt = amount ?? 0;
            const freq =
              freqType?.charAt(0).toUpperCase() + freqType?.slice(1) || "";
            const emp = employmentTypeMap[employmentType] || "";

            let display = `${curr} ${amt}`;
            if (freq) display += ` / ${freq}`;
            if (emp) display += ` / ${emp}`;
            return display.trim();
          })()
          : "N/A",
        submittedOn: submission?.addedOn
          ? formatDateTime(convertFromUTC(submission?.addedOn))
          : "N/A",
        uiid: submission?.uiid || null,
        candidateId: candidate?.uiid || null,
        notes: submission?.notes ?? [],
      };
    });
  };

  const getSubmissionCounts = (submissions = []) => {
    const counts = { shortlisted: 0, pipeline: 0, submission: 0 };

    (submissions || []).forEach((sub) => {
      const lastStatus =
        sub?.statusHistory?.[sub?.statusHistory?.length - 1]?.status;

      if (lastStatus === 1) counts.shortlisted += 1;
      else if (lastStatus === 2) counts.pipeline += 1;
      else if (lastStatus === 3) counts.submission += 1;
    });

    return counts;
  };

  const handleSelectionChange = (rows) => {
    setSelectedRows(rows);
    const ids = rows
      .map((rowId) => initialJobs.find((job) => job?.id === rowId)?.uiid)
      .filter(Boolean);
    setJobPostIds(ids);
  };

  const handleFetchTalentMatch = async (job) => {
    try {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: true }));
      const res = await fetchTalentMatch({
        coll: "TalentMatche",
        pg: 1,
        lim: 10,
        ref: "JobPosting Candidate",
        fil: { uiid: { type: "IN", value: job.talentMatchIds || [] } },
        ret: "uiid candidateId jobPostId addedBy addedOn statusHistory",
        extret: "uiid firstName",
        incl: [
          "jobInfo.workAuth jobInfo.location jobInfo.payments.billRate jobInfo.payments.payRate",
          "uiid firstName lastName mobile source resumes currentEmp noticePeriod salaryInfo.payRate location",
        ],
      });

      if (res?.data?.data) {
        const structuredRows = mapSubmissionsToRows(res?.data?.data);
        setAccordionData((prev) => ({
          ...prev,
          [job.uiid]: structuredRows,
        }));
      } else {
        showToast("No talent match data found", "info");
        setAccordionData((prev) => ({ ...prev, [job?.uiid]: [] }));
      }
    } catch (err) {
      console.error("❌ Error fetching talent match:", err);
      showToast("Failed to fetch talent match", "error");
    } finally {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: false }));
    }
  };

  const handleSubmissionStatusUpdate = async ({
    submissionId,
    candidateId,
    newStatus,
    isTalentMatch,
    type,
  }) => {
    // Update the local accordion data to reflect the change
    setAccordionData((prev) => {
      const updatedData = { ...prev };

      // Find and update the specific row in the accordion data
      Object.keys(updatedData).forEach((jobUiid) => {
        updatedData[jobUiid] = updatedData[jobUiid].map((row) => {
          if (row.submissionId === submissionId) {
            return {
              ...row,
              applicationStatus: [
                ...(row.applicationStatus || []),
                {
                  status: newStatus,
                  addedBy: { uiid: user?.data?.uiid },
                  addedOn: new Date().toISOString(),
                },
              ],
            };
          }
          return row;
        });
      });

      return updatedData;
    });
  };

  const handleFetchSubmissions = async (job, type = "submitted") => {
    try {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: true }));
      const submissionIds = (job?.submissions || [])
        .map((sub) => (typeof sub === "object" ? sub?.uiid : sub))
        .filter(Boolean);
      let fil = {
        uiid: { type: "IN", value: submissionIds || [] },
      };
      if (type !== "submitted") {
        fil["statusHistory.status"] = {
          type: "ARRAY_LAST_TWO_FIELDS_EQ",
          value: type === "shortlisted" ? 1 : type === "pipelined" ? 2 : 3,
        };
      }
      const res = await fetchAllSubmissions({
        coll: "Submission",
        pg: 1,
        lim: 10,
        ref: "JobPosting Candidate",
        fil: fil,
        ret: "uiid candidateId jobPostId addedBy addedOn statusHistory",
        extret: "uiid firstName",
        incl: [
          "jobInfo.workAuth jobInfo.location jobInfo.payments.billRate jobInfo.payments.payRate",
          "uiid firstName lastName mobile source resumes currentEmp noticePeriod salaryInfo.payRat exp location workAuth",
        ],
      });
      if (res?.data) {
        const rows = mapSubmissionsToRows(res?.data?.data || []);
        setAccordionData((prev) => ({ ...prev, [job?.uiid]: rows }));
      }
    } catch (err) {
      console.error("Error fetching submissions:", err);
    } finally {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: false }));
    }
  };

  const onlineStatus = [true, false];

  const initialJobs = (jobs || []).map((job, index) => {
    const submissionCounts = getSubmissionCounts(job?.submissions || []);

    return {
      id: index,
      uiid: job?.uiid,
      icons: "",
      code: job?.jobInfo?.jobCode || "",
      jobTitle: formatWords2(job?.jobId?.title || ""),
      companyName: job?.jobId?.companyId?.name
        ? formatWords2(job?.jobId?.companyId?.name)
        : "N/A",

      jobLocation: job?.jobInfo?.location
        ? [
          job?.jobInfo?.location?.city,
          job?.jobInfo?.location?.state,
          job?.jobInfo?.location?.country,
        ]
          .filter(Boolean)
          .join(", ")
        : "N/A",
      jobStatus: job?.jobId?.status,
      contact: Math.floor(Math.random() * 6),
      online: onlineStatus[Math.floor(Math.random() * 2)],
      applications: job?.talentMatch?.ids?.length || 0,
      shortlisted: submissionCounts?.shortlisted,
      pipelined: submissionCounts?.pipeline,
      // submitted: submissionCounts?.submission,
      submitted: job?.submissions?.length,
      submissions: job?.submissions || [],
      clientBill: formatPayment(job?.jobInfo?.payments?.billRate),
      payBill: formatPayment(job?.jobInfo?.payments?.payRate),
      deliveryManager: formatWords2(job?.assignedTo?.firstName) || "-",
      jobCreatedBy: formatWords2(job?.addedBy?.firstName),
      jobCreatedOn: job?.addedOn
        ? formatDateTime(convertFromUTC(job?.addedOn))
        : "",
      minSalary: job?.jobInfo?.payments?.payRate?.amount?.min || 0,
      maxSalary: job?.jobInfo?.payments?.payRate?.amount?.max || 0,
      notes: job?.notes || [],
      statusHistory: job?.statusHistory || [],
      recruiter: job?.notifyTo || "-",
      talentMatchIds: job?.talentMatch?.ids || [],
      canEdit:
        user?.data?.role?.type === 3 && job?.addedBy?.uiid === user?.data?.uiid,
    };
  });

  const [recruiter, setRecruiter] = useState(
    initialJobs.reduce((acc, job) => {
      // acc[job.id] = job.recruiter;
      acc[job?.uiid] = job?.recruiter;
      return acc;
    }, {}),
  );

  const colJobDetails = [
    {
      key: "icons",
      label: "",
      width: "min-w-[200px]! max-w-[350px]!",
      render: (row) => {
        const contactEmpty = row?.contact > 0;

        return (
          <div className="flex items-center gap-2">
            <div>
              <DropdownMenuNew
                MenuSection={
                  <div className="flex flex-col">
                    {row?.canEdit && (
                      <Button
                        title={"Edit"}
                        variant="text"
                        color="black"
                        size="xs-sm"
                        className="!justify-start py-2"
                        // onClick={() => setEditModal(true)}
                        // onClick={() => {
                        //   setSelectedJobId(row?.uiid);
                        //   setEditModal(true);
                        // }}
                      />
                    )}
                    <Button
                      title={"Publish"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-1"
                    />
                    <Button
                      title={"Schedule Interview"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-2"
                      onClick={() => setScheduleModal(true)}
                    />

                    <Button
                      title={"Compose Mail"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-2"
                      onClick={() => setIsModalOpen(true)}
                    />
                  </div>
                }
              >
                <Button
                  icon={"more_vert"}
                  variant="text"
                  type="icon"
                  size="sm"
                  color="black"
                />
              </DropdownMenuNew>
            </div>
            <div>
              <Button
                type="icon"
                icon={"contacts"}
                color={contactEmpty ? "success" : "gray-500"}
                variant="text"
              />
            </div>
            <div
              className={`w-3 h-3 rounded-full ${row.online ? "bg-success" : "bg-gray-200"
                }`}
            ></div>
            <div className="flex items-center gap-2">
              {row?.applications > 0 && (
                <SmartTooltip description="Talent Match" noicon>
                  <InfoCircle
                    color="invoiced"
                    colorDepth="100"
                    className="text-white"
                    value={row?.applications}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row.id, "applications");
                      handleFetchTalentMatch(row);
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}

              {row?.shortlisted > 0 && (
                <SmartTooltip description="Shortlisted" noicon>
                  <InfoCircle
                    className="text-white"
                    value={row?.shortlisted}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row.id, "shortlisted");
                      handleFetchSubmissions(row, "shortlisted");
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}
              {row?.pipelined > 0 && (
                <SmartTooltip description="Pipeline" noicon>
                  <InfoCircle
                    color="gray"
                    colorDepth="800"
                    className="text-white"
                    value={row?.pipelined}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row.id, "pipelined");
                      handleFetchSubmissions(row, "pipelined");
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}
              {row?.submitted > 0 && (
                <SmartTooltip description="Submission" noicon>
                  <InfoCircle
                    color="info"
                    className="text-white"
                    value={row?.submitted}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row.id, "submitted");
                      handleFetchSubmissions(row);
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}
            </div>
            {row?.notes && row?.notes.length > 0 && (
              <div>
                {/* <Button
                  type="icon"
                  icon={"mark_unread_chat_alt"}
                  variant="text"
                  color="warning"
                  onClick={() => {
                    if (!selectedRows.includes(row.id)) {
                      setSelectedRows([...selectedRows, row.id]);
                    }
                    setShowDataId([row.id]);
                    setShowSingleNotes(true);
                  }}
                /> */}
                <DualIcon
                  size="sm"
                  badgeIconColor={
                    row?.notes?.length > 0 ? "bg-success" : "bg-dark"
                  }
                  // onClick={() => {
                  //   if (!selectedRows.includes(row.id)) {
                  //     setSelectedRows([...selectedRows, row.id]);
                  //   }
                  //   setShowDataId([row.id]);
                  //   setShowSingleNotes(true);
                  //   setIsNotePanelOpen(false);
                  //   setNoteId(row?.uiid)
                  //   handleFetchNotes(row);
                  // }}
                  // onClick={() => {
                  //   const newSelected = [row?.id];
                  //   setSelectedRows(newSelected);

                  //   const ids = newSelected
                  //     .map(
                  //       (rId) =>
                  //         initialJobs.find((job) => job?.id === rId)?.uiid,
                  //     )
                  //     .filter(Boolean);
                  //   setJobPostIds(ids);

                  //   setShowDataId([row?.id]);

                  //   setShowSingleNotes(true);
                  //   setIsNotePanelOpen(false);

                  //   setNoteId(row?.uiid);

                  //   handleFetchNotes(row);
                  // }}
                />
              </div>
            )}
          </div>
        );
      },
    },
    {
      key: "code",
      label: "Job Code",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <Link
          to={`/ats/jobs/ai-job-details`}
          className="text-info"
          state={{ uiid: row?.uiid }}
          onClick={() => {
            sessionStorage.setItem("selectedJobUiid", row?.uiid);
            sessionStorage.setItem(
              "prevJobsPage",
              window.location.pathname + window.location.search,
            );
          }}
        >
          {row?.code}
        </Link>
      ),
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[230px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.jobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.jobTitle}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "companyName",
      label: "Company Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.companyName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.companyName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobLocation",
      label: "Job Location",
      render: (row) => (
        <SmartTooltip
          description={formatWords2(row?.jobLocation) != "-" ? formatWords2(row?.jobLocation) : "N/A"}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{formatWords2(row?.jobLocation) != "-" ? formatWords2(row?.jobLocation) : "N/A"}</div>
        </SmartTooltip>
      ),
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "jobStatus",
      label: "Job Status",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => {
        const lastStatus =
          row?.statusHistory && row?.statusHistory?.length > 0
            ? row?.statusHistory[row?.statusHistory?.length - 1]?.status
            : 2;
        const currentOption =
          statusOptions.find((opt) => opt.value === lastStatus) ||
          statusOptions.find((opt) => opt.value === 2);

        return (
          <div className="w-[180px] min-w-[160px]">
            <FormFieldSet
              type="select"
              noTitle
              size="sm"
              options={statusOptions}
              value={currentOption}
              showSearch
              // onChange={(opt) => handleStatusChange(opt, row)}
            // showButton
            />
          </div>
        );
      },
    },
    {
      key: "clientBill",
      label: "Client Bill",
      width: "min-w-[180px]! max-w-[220px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.clientBill}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.clientBill}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "payBill",
      label: "Pay Bill",
      width: "min-w-[180px]! max-w-[220px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.payBill}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.payBill}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "deliveryManager",
      label: "Delivery Manager",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.deliveryManager}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.deliveryManager}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "recruiter",
      label: "Recruiter",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => {
        // const assigned = recruiter[row?.uiid] || [];
        // const bot = assigned.find(r => allRecruiters.find(o => o.value.endsWith(`-${r?.uiid}`) && o.userType === 2));
        // const botName = bot ? `${bot.firstName} ${bot.lastName || ""}`.trim() : "Unassigned";
        const botRecruiter = row?.recruiter?.find((recruiter) => recruiter?.userType == 2);
        return (
          <div className="flex items-center gap-1.5 w-[180px] min-w-[160px]">
            <Button type="icon" color="danger" variant="text" icon="android" className="shrink-0"/>
            <span className="text-sm line-clamp-1 truncate">{`${botRecruiter?.firstName} ${botRecruiter?.lastName}`}</span>
          </div>
        );
      },
    },
    {
      key: "jobCreatedBy",
      label: "Job Created By",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "jobCreatedOn",
      label: "Job Created On",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.jobCreatedOn}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.jobCreatedOn}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "minSalary",
      label: "Min Salary",
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "maxSalary",
      label: "Max Salary",
      width: "min-w-[150px]! max-w-[200px]!",
    },
  ];

  const mappedRows = mapTableRows(initialJobs, colJobDetails);

  return (
    <div className="flex flex-col mt-5 overflow-auto flex-1">
      <div className="flex flex-grow overflow-auto gap-4 mx-0.5">
        <TableAdv
          showCheckbox
          // singleSelection
          columns={colJobDetails}
          rows={mappedRows}
          //   defaultSelectedRows={showDataId}
          //   serverPagination={true}
          //   totalCount={totalCount}
          //   page={page}
          expandedRows={expandedRows}
          //   limit={limit}
          tableId={"BDMAIJobsTable"}
          //   onPaginationChange={setPage}
          //   onLimitChange={handleLimitChange}
          //   info={"info"}
          //   serverFiltering={true}
          //   onFilterChange={handleFilterChange}
          //   serverOnSearch={(key, value) => {
          //     setSearchValue(value);
          //     if (!value) {
          //       fetchAllJobs();
          //     }
          //   }}
          // tdClassName="!py-1"
          // accrodian={({ row, type }) => (
          //   <JobsAccordion row={row} type={type} />
          // )}
          // accrodian={({ row, type }) => {
          //   const submissionRows = accordionData[row.uiid] || [];
          //   return (
          //     <JobsAccordion
          //       rowData={submissionRows}
          //       type={type}
          //       loading={accordionLoading?.[row.uiid]}
          //     />
          //   );
          // }}
          accordion={(row, accordionType) => {
            const submissionRows = accordionData[row?.uiid] || [];
            return (
              <JobsAccordion
                rowData={submissionRows}
                type={accordionType}
                loading={accordionLoading?.[row?.uiid]}
                onStatusUpdate={handleSubmissionStatusUpdate}
              />
            );
          }}
          defaultSelectedRows={selectedRows}
          onSelectionChange={handleSelectionChange}
          toolbarRight={{
            search: true,
            fullScreen: true,
            filter: true,
            add: selectedRows.length > 0 && [
              {
                component: (
                  <Button
                    title="Add Note"
                    icon="add"
                    size="sm"
                    onClick={() => {
                      // setShowDataId([...selectedRows]);
                      // setIsNotePanelOpen(true);
                    }}
                  />
                ),
              },
            ],
          }}
        />
      </div>
      <ScheduleCallModal isOpen={scheduleCall} onClose={()=>setScheduleCall(false)}/>
      <Modal isOpen={scheduleModal} showCloseButton={false} width="max-w-7xl">
        <div className="p-2">
          <Button
            color="black"
            icon={"arrow_left_alt"}
            variant="text"
            title={"Schedule Interview"}
            className="!px-0 font-[500]"
            size="lg"
            onClick={() => setScheduleModal(false)}
          />
          <TableAdv
            rows={scheduleInterviewRows}
            columns={scheduleInterviewCols}
            showCheckbox
            tableId={"BDMAllJobsTable_scheduleinterview"}
            tdClassName="!py-3"
            onSelectionChange={setSelectedModalRows}
            defaultSelectedRows={selectedModalRows}
            toolbarRight={{
              search: true,
              fullScreen: true,
              add: [
                {
                  component: <Button title="Bulk Email" icon="add" size="sm" />,
                },
              ],
            }}
          />
          <div className="flex justify-end my-5">
            <Button
              title={"Cancel"}
              onClick={() => setScheduleModal(false)}
              variant="outlined"
            />
          </div>
        </div>
      </Modal>
      <Modal isOpen={isModalOpen} showCloseButton={false} width="max-w-6xl">
        <div>
          <Button
            color="black"
            icon={"arrow_left_alt"}
            variant="text"
            title={"Compose Mail"}
            className="!px-0 font-[500]"
            size="xl"
            onClick={() => setIsModalOpen(false)}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-5">
          <FormFieldSet
            type="select"
            title="Email Source"
            placeholder="Select"
            options={[
              { label: "Gmail", value: 1 },
              { label: "Outlook", value: 2 },
              { label: "Mailgun", value: 3 },
              { label: "AWS-SES", value: 4 },
            ]}
          // value={formData.emailSource}
          // onChange={(value) => handleChange("emailSource", value)}
          // error={errors.emailSource}
          />
          <FormFieldSet
            type="select"
            title="Email Account"
            placeholder="Select Account"
            options={[
              { label: "Brown", value: 1 },
              { label: "Aden", value: 2 },
            ]}
          // value={formData.emailAccount}
          // onChange={(value) => handleChange("emailAccount", value)}
          // error={errors.emailAccount}
          />
          <FormFieldSet
            type="datepicker"
            title="Date Picker"
            placeholder="Select Date"
          // value={formData.datePicker}
          // onChange={(value) => handleChange("datePicker", value)}
          // error={errors.datePicker}
          />
          <FormFieldSet
            type="select"
            title="Template"
            placeholder="Select"
            options={[
              { label: "Brown", value: 1 },
              { label: "Aden", value: 2 },
            ]}
          // value={formData.template}
          // onChange={(value) => handleChange("template", value)}
          // error={errors.template}
          />
          <FormFieldSet
            title="Subject"
            placeholder="Select"
          // value={formData.subject}
          // onChange={(value) => handleChange("subject", value)}
          // error={errors.subject}
          />
        </div>
        <div className="flex flex-col my-4 gap-4">
          <FormFieldSet
            value={["simon@tektreeinc.com", "john.doe@tektreeinc.com"]}
            maxCount={50}
            type="toMailIds"
            title="Include Test Emails Here: 2"
          />
          <FormFieldSet
            type="textArea"
            title="Text Here"
            rows={5}
            placeholder="Enter Text Here"
          // value={formData.emailText}
          // onChange={(value) => handleChange("emailText", value)}
          // error={errors.emailText}
          />
        </div>
        <div className="flex justify-end gap-5 my-10">
          <Button
            variant="outlined"
            title={"Cancel"}
            onClick={() => setIsModalOpen(false)}
          />
          <Button title={"Send Email"} />
        </div>
      </Modal>
      <Backdrop isOpen={loading}>
        <LogoLoader/>
      </Backdrop>
    </div>
  );
};

export default AiRecruiterJobs;
